export const Errors =  {
    InvalidPlan : 1018,
    CompanyDisabled: 1019
}